var _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaterDrip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 147,
    viewBox: "0 0 187 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_164_4494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.6276 55.943C74.5276 46.831 79.7766 38.468 84.9026 30.028C88.7169 23.8197 91.5623 17.0661 93.3406 10C95.1296 18.838 99.4986 26.471 104.022 34.02C106.804 38.662 110.059 43.046 112.546 47.834C117.864 58.076 120.946 68.627 114.958 79.813C112.981 83.504 109.833 86.072 106.813 88.785C97.6466 93.978 88.4986 93.547 79.3836 88.665C78.8771 88.3141 78.413 87.9057 78.0006 87.448C78.1356 86.848 77.8136 86.562 77.2846 86.422C76.706 85.4512 75.8187 84.7024 74.7646 84.295C74.6693 83.9052 74.4858 83.5426 74.2281 83.235C73.9705 82.9274 73.6456 82.6831 73.2786 82.521C68.1686 75.7 67.4376 68.13 69.4606 60.097C69.8116 58.703 70.2366 57.328 70.6276 55.943ZM89.3126 35.564C86.1126 40.958 82.7916 46.281 79.7636 51.764C77.0056 56.764 75.2346 62.146 75.5316 67.954C75.6646 70.554 75.8576 73.374 79.6566 73.432C83.8726 73.497 83.8666 70.487 83.6166 67.732C83.0286 61.277 84.4816 55.238 86.5106 49.201C88.0026 44.781 89.7026 40.355 89.3126 35.564Z",
    fill: "#FCFCFC",
    fillOpacity: 0.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_164_4494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.991 110.262L129.825 110.079C130.375 110.139 130.931 110.082 131.458 109.913C131.985 109.744 132.471 109.466 132.884 109.098C138.046 108.014 142.846 105.63 146.83 102.172C152.143 97.8459 152.016 93.9369 146.698 89.4949C141.38 85.0529 134.893 82.8889 128.477 80.6149C128.897 78.5989 130.283 79.9149 131.121 80.0959C138.278 81.6039 145.39 83.3209 150.781 88.7889C156.372 94.4599 155.813 97.9369 151.423 103.645C148.841 107 144.939 108.712 141.678 111.223C113.196 123.129 84.2125 123.723 54.8685 114.915C48.4765 112.997 42.4175 110.22 37.3605 105.715C30.1605 99.3009 30.1955 93.3209 37.5745 86.9919C43.2285 82.1429 50.0515 80.5519 57.3605 80.6119C52.6985 82.7389 48.0775 84.9659 43.3395 86.9119C42.4334 87.2335 41.597 87.7253 40.8755 88.3609C34.1055 94.7749 34.3615 98.9179 42.3195 103.895C51.8665 109.865 62.5485 112.65 73.6265 114.003C91.5525 116.191 109.356 115.822 126.918 111.151C127.326 111.041 127.633 110.566 127.991 110.262Z",
    fill: "#FCFCFC",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "water-drip__circle-3",
    d: "M140.494 121.301L142.987 121.031C143.735 121.119 144.491 121.036 145.208 120.787C145.924 120.538 146.584 120.129 147.145 119.586C154.163 117.99 160.689 114.478 166.104 109.385C173.327 103.013 173.154 97.2547 165.925 90.7118C158.695 84.1688 149.876 80.9813 141.154 77.6318C141.725 74.6623 143.609 76.6007 144.749 76.8673C154.478 79.0886 164.147 81.6177 171.475 89.6718C179.076 98.025 178.316 103.147 172.348 111.554C168.838 116.496 163.533 119.018 159.1 122.716C120.381 140.254 80.9799 141.128 41.0884 128.155C32.3989 125.329 24.162 121.239 17.2873 114.603C7.49934 105.156 7.54691 96.3473 17.5782 87.0249C25.2645 79.8825 34.54 77.539 44.4762 77.6274C38.1385 80.7604 31.8565 84.0407 25.4154 86.9071C24.1836 87.3807 23.0466 88.1052 22.0658 89.0414C12.8623 98.4891 13.2103 104.592 24.0288 111.923C37.0074 120.716 51.529 124.818 66.5889 126.811C90.9582 130.034 115.16 129.491 139.035 122.61C139.59 122.448 140.007 121.749 140.494 121.301Z",
    fill: "#FCFCFC",
    fillOpacity: 0.9
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_164_4494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.955 99.385C122.289 98.824 127.485 98.085 128.754 93.795C130.09 89.295 123.917 89.023 121.69 86.288C128.423 86.666 132.561 90.412 131.642 95.283C131.006 98.654 127.654 99.416 125.735 101.55C105.842 108.825 85.7625 109.065 65.5585 103.018C63.3474 102.304 61.2317 101.322 59.2585 100.095C56.5075 98.458 53.4165 96.242 54.3015 92.821C54.7288 91.1403 55.6436 89.6235 56.9308 88.4614C58.2179 87.2993 59.82 86.5438 61.5355 86.2899C63.0083 85.9155 64.5267 85.7512 66.0455 85.802C64.5455 86.723 63.0105 87.5889 61.5585 88.5789C59.7875 89.7859 57.3965 90.948 57.7975 93.397C58.2145 95.939 60.4755 97.351 62.8975 98.097C71.1546 100.65 79.7336 102.013 88.3755 102.143C96.6135 102.276 104.857 102.407 112.93 100.306C113.227 100.493 113.58 100.569 113.928 100.52C114.276 100.472 114.595 100.301 114.83 100.04C115.364 100.195 115.929 100.216 116.474 100.102C117.019 99.9879 117.527 99.7417 117.955 99.385Z",
    fill: "#FCFCFC",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_164_4494",
    x: 58.4158,
    y: 0,
    width: 69.8147,
    height: 102.506,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.909804 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_4494"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_4494",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_164_4494",
    x: 0,
    y: 66,
    width: 187,
    height: 81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.909804 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_4494"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_4494",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_164_4494",
    x: 44.1472,
    y: 75.793,
    width: 97.6216,
    height: 41.5073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.909804 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_4494"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_4494",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDrip);
export default __webpack_public_path__ + "static/media/water-drip.da4d950ea61797d622147608f042b9a4.svg";
export { ForwardRef as ReactComponent };